import React, { useContext } from "react";
import ThrottlingCheckbox from "integrations/components/ThrottlingCheckbox";
import { Input } from "components/bootstrap";
import FormDataContext from "integrations/contexts/FormDataContext";
import { AdvancedOptionsContext } from "integrations/aws/context/AdvancedOptions";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
const FormAdvancedOptions = ({ onChange }) => {
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const {
    awsCloudWatchBatchSize,
    overrideSource,
    awsCloudWatchThrottleEnabled,
    awsCloudWatchAddFlowLogPrefix,
    awsCloudWatchStoreFullMessage
  } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  return /* @__PURE__ */ React.createElement(AdditionalFields, { title: "Advanced Options", visible: isAdvancedOptionsVisible, onToggle: handleToggle }, /* @__PURE__ */ React.createElement(
    ThrottlingCheckbox,
    {
      id: "awsCloudWatchThrottleEnabled",
      defaultChecked: awsCloudWatchThrottleEnabled == null ? void 0 : awsCloudWatchThrottleEnabled.value,
      onChange
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "awsCloudWatchAddFlowLogPrefix",
      type: "checkbox",
      value: "enable-logprefix",
      defaultChecked: awsCloudWatchAddFlowLogPrefix && awsCloudWatchAddFlowLogPrefix.value,
      onChange,
      label: "Add Flow Log field name prefix",
      help: 'Add field with the Flow Log prefix e. g. "src_addr" -> "flow_log_src_addr".'
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "awsCloudWatchStoreFullMessage",
      type: "checkbox",
      value: "enable-store-full-message",
      defaultChecked: awsCloudWatchStoreFullMessage == null ? void 0 : awsCloudWatchStoreFullMessage.value,
      onChange,
      label: "Store full message?",
      help: "Store the original Kinesis/CloudWatch log event payload in the full_message field."
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "overrideSource",
      type: "text",
      value: overrideSource == null ? void 0 : overrideSource.value,
      onChange,
      label: "Override Source (optional)",
      help: "The message source is set to aws-kinesis-raw-logs by default. If desired, you may override it with a custom value."
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "awsCloudWatchBatchSize",
      type: "number",
      value: awsCloudWatchBatchSize.value || awsCloudWatchBatchSize.defaultValue,
      onChange,
      label: "Kinesis Record batch size",
      help: "The number of Kinesis records to fetch at a time. Each record may be up to 1MB in size. The AWS default is 10,000. Enter a smaller value to process smaller chunks at a time."
    }
  ));
};
export default FormAdvancedOptions;
